import * as React from "react";
import { UitkText } from "uitk-react-text";
import { LocalizedComponentProps, withLocalization } from "@shared-ui/localization-context";

export interface RateCalendarFooterProps extends LocalizedComponentProps {
  displayPositive: boolean;
  displayNegative: boolean;
}

@withLocalization
export class RateCalendarFooter extends React.Component<RateCalendarFooterProps> {
  public render() {
    const { formatText } = this.props.l10n;

    const legendNegative = formatText("wizard.ratecalendar.content.negative.ariaLabel");
    const legendPositive = formatText("wizard.ratecalendar.content.positive.ariaLabel");

    return (
      <>
        {this.props.displayPositive && (
          <div className="rate-calendar-footer-wrapper all-r-padding-three uitk-type-200 uitk-type-regular">
            <div className="rate-calendar-footer positive">
              <UitkText theme="positive" size={100}>
                ▼
              </UitkText>
            </div>
            <UitkText weight={"bold"}>{legendPositive}</UitkText>
          </div>
        )}
        {this.props.displayNegative && (
          <div className="rate-calendar-footer-wrapper all-r-padding-three uitk-type-200 uitk-type-regular">
            <div className="rate-calendar-footer negative">
              <UitkText theme="negative" size={100}>
                ▲
              </UitkText>
            </div>
            <UitkText weight={"bold"}>{legendNegative}</UitkText>
          </div>
        )}
      </>
    );
  }
}
